import { render, staticRenderFns } from "./resistanceModification.vue?vue&type=template&id=673f0fb2&scoped=true&"
import script from "./resistanceModification.vue?vue&type=script&lang=js&"
export * from "./resistanceModification.vue?vue&type=script&lang=js&"
import style0 from "./resistanceModification.vue?vue&type=style&index=0&id=673f0fb2&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "673f0fb2",
  null
  
)

export default component.exports